export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const LOGIN_LOADING = "LOGIN_LOADING"

export const GET_USERS = "GET_USERS";

export const GET_SOURCE_BUSINESS = "GET_SOURCE_BUSINESS";
export const GET_SOURCE_BUSINESSES = "GET_SOURCE_BUSINESSES";
export const ADD_SOURCE_BUSINESS = "ADD_SOURCE_BUSINESS";
export const UPDATE_SOURCE_BUSINESS = "UPDATE_SOURCE_BUSINESS";
export const REMOVE_SOURCE_BUSINESS = "REMOVE_SOURCE_BUSINESS";
export const DELETE_SOURCE_BUSINESS = "DELETE_SOURCE_BUSINESS";
export const ERR_SOURCE_BUSINESS = "ERR_SOURCE_BUSINESS";
export const LOADING_SOURCE_BUSINESS = "LOADING_SOURCE_BUSINESS";

export const GET_OFFERINGS = "GET_OFFERINGS";
export const GET_EXPIRING_OFFERS = "GET_EXPIRING_OFFERS"; 
export const UPDATE_VERFIED = "UPDATE_VERIFIED";
export const ERR_OFFERING = "ERR_OFFERING";
export const LOADING_OFFERINGS = "LOADING_OFFERINGS";

export const GET_VOUCHERS = "GET_VOUCHERS";
export const DELETE_VOUCHERS = "DELETE_VOUCHERS";
export const ERR_VOUCHERS = "ERR_VOUCHERS";
export const LOADING_VOUCHERS = "LOADING_VOUCHERS";

export const GET_BATCH = "GET_BATCH";
export const GET_BATCHES = "GET_BATCHES";
export const ADD_BATCH = "ADD_BATCH";
export const UPDATE_BATCH = "UPDATE_BATCH";
export const REMOVE_BATCH = "REMOVE_BATCH";
export const DELETE_BATCH = "DELETE_BATCH";
export const ERR_BATCH = "ERR_BATCH";
export const LOADING_BATCH = "LOADING_BATCH";

export const GET_COLLECTIONS = "GET_COLLECTIONS";
export const ERR_COLLECTION = "ERR_COLLECTION";
export const LOADING_COLLECTIONS = "LOADING_COLLECTIONS";

export const GET_CAMPAIGN = "GET_CAMPAIGN";
export const GET_CAMPAIGNS = "GET_CAMPAIGNS";
export const ADD_CAMPAIGN = "ADD_CAMPAIGN";
export const UPDATE_CAMPAIGN = "UPDATE_CAMPAIGN";
export const REMOVE_CAMPAIGN = "REMOVE_CAMPAIGN";
export const DELETE_CAMPAIGN = "DELETE_CAMPAIGN";
export const ERR_CAMPAIGN = "ERR_CAMPAIGN";
export const LOADING_CAMPAIGNS = "LOADING_CAMPAIGNS";

export const GET_DASHBOARD = "GET_DESHBOARD";
export const ERR_DASHBOARD = "ERR_DESHBOARD";

export const GET_REPORTS = "GET_REPORTS";
export const GET_CAMP_COLL_OFF = "GET_CAMP_COLL_OFF";
export const ERR_REPORTS = "ERR_REPORTS";
export const LOADING_REPORTS = "LOADING_REPORTS";